import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Textarea = forwardRef(({
    id,
    label,
    placeholder = '',
    className = '',
    rows = 4,
    error = '',
    ...props
}, ref) => {
    const textareaId = id || `textarea-${label.replace(/\s+/g, '-').toLowerCase()}`;

    const baseTextareaClasses = 'block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border appearance-none focus:outline-none focus:ring-0 peer resize-none';
    const baseTextareaStateClasses = error
        ? 'border-red-600 focus:border-red-600'
        : 'border-gray-400 focus:border-blue-700';
    const baseLabelClasses = 'absolute text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 ml-1 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/4 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4';
    const baseLabelStateClasses = error
        ? 'text-red-600 peer-focus:text-red-600'
        : 'text-gray-500 peer-focus:text-blue-600';

    return (
        <div className="relative w-full">
            <textarea
                id={textareaId}
                rows={rows}
                className={`${baseTextareaClasses} ${baseTextareaStateClasses} ${className}`}
                placeholder=" "
                ref={ref}
                aria-invalid={error ? 'true' : 'false'}
                aria-describedby={error ? `${textareaId}-error` : undefined}
                {...props}
            ></textarea>
            <label
                htmlFor={textareaId}
                className={`${baseLabelClasses} ${baseLabelStateClasses}`}
            >
                {label}
            </label>
            {error && (
                <p id={`${textareaId}-error`} className="mt-2 text-xs text-red-600">
                    {error}
                </p>
            )}
        </div>
    );
});

Textarea.displayName = 'Textarea';

Textarea.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    rows: PropTypes.number,
    error: PropTypes.string,
};

export default Textarea;
